import { render, staticRenderFns } from "./ConversionSettings.vue?vue&type=template&id=978e47fe"
import script from "./ConversionSettings.vue?vue&type=script&lang=ts"
export * from "./ConversionSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports